"use client";

import { Text } from "@chakra-ui/react";
import type { ChatBotMessage } from "../types";

interface ChatbotMessageDetailsProps {
  msg: ChatBotMessage;
}

export default function ChatbotMessageDetails({
  msg,
}: ChatbotMessageDetailsProps) {
  return (
    <Text
      className="timestamp"
      fontSize="xs"
      position="absolute"
      // @ts-ignore This works but Chakra/TS complains
      bottom="-16px"
      // @ts-ignore This works but Chakra/TS complains
      right={msg.sender === "user" ? "4px" : undefined} // Right-align for user
      // @ts-ignore This works but Chakra/TS complains
      left={msg.sender === "user" ? undefined : "4px"} // Left-align for others
      // Center for system messages
      textAlign={msg.sender === "system" ? "center" : undefined}
      // @ts-ignore This works but Chakra/TS complains
      opacity={0}
      // @ts-ignore This works but Chakra/TS complains
      transition="opacity 0.2s"
    >
      {msg.timestamp}
      {msg.sender === "user" && msg.status && <> • {msg.status}</>}
    </Text>
  );
}
